import React, { useState } from 'react';
import { Button, Offcanvas, Form } from 'react-bootstrap';

const sortOptions = [
  { label: 'Price High to Low', value: 'highToLow' },
  { label: 'Price Low to High', value: 'lowToHigh' },
  { label: 'Best Sellers', value: 'BestSeller' },
  { label: 'Most Viewed', value: 'MostView' },
  { label: 'New Products', value: 'NewProduct' },
];

const FloatingButtonWithSidebar = ({ onSortChange, selectedSort, productFilters }) => {
  const [show, setShow] = useState(false);
  const [sortAccordionOpen, setSortAccordionOpen] = useState(false);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);
  
  const toggleSortAccordion = () => {
    setSortAccordionOpen(!sortAccordionOpen);
  };

  const handleSort = (event) => {
    if (onSortChange) onSortChange(event);
  };

  const productFiltersWithClose = React.cloneElement(productFilters, {
    onClose: handleClose
  });

  return (
    <div className="d-lg-none" style={{display: show ? 'none' : 'block'}}>
      {/* Floating Button */}
      <Button
        variant="primary"
        onClick={handleShow}
        className='bg-fld shadow-'
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          borderRadius: '50%',
          width: '60px',
          height: '60px',
          zIndex: 1050,
          backgroundColor: '#de0f3f',
          border: '0.5px solid white'
        }}
      >
        <i className="bi h3 bi-sort-up"></i>
      </Button>

      {/* Sidebar (Offcanvas) */}
      <Offcanvas show={show} className="product-filters" onHide={handleClose} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Filters & Sort</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {/* Sort By Accordion */}
          <div className="accordion" id="sortByAccordion">
            <div className="accordion-item py-2" aria-readonly={true}>
              <h2 className="accordion-header">
                <button
                  className={`accordion-button ${sortAccordionOpen ? '' : 'collapsed'}`}
                  type="button"
                  style={{fontWeight: '600'}}
                  onClick={toggleSortAccordion}
                  aria-expanded={sortAccordionOpen} 
                  aria-controls="sort-accordion"
                  data-bs-toggle="collapse"
                >
                  Sort By
                </button>
              </h2>
              <div
                id="sort-accordion"
                className={`accordion-collapse collapse ${sortAccordionOpen ? 'show' : ''}`}
                aria-labelledby="sortByHeading"
              >
                <div className="accordion-body">
                  <Form className="filter-options">
                    {sortOptions.map((option) => (
                      <div className="checkbox-widget" key={option.value}>
                        <Form.Check
                          type="radio"
                          id={`sort-${option.value}`}
                          name="sortOptions"
                          style={{fontSize: '14px', lineHeight: 1.2}}
                          label={option.label}
                          value={option.value}
                          checked={selectedSort === option.value}
                          onChange={handleSort}
                          className="mb-2"
                        />
                      </div>
                    ))}
                  </Form>
                </div>
              </div>
            </div>
          </div>
          <hr />
          {productFiltersWithClose}
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default FloatingButtonWithSidebar;
